import React from 'react';
import { GraduationCap } from 'lucide-react';
export function ExpertSection() {
  return <section className="w-full bg-bg-main py-24 px-4 border-t border-border-light" data-id="element-53">
      <div className="max-w-3xl mx-auto text-center" data-id="element-54">
        <div className="w-24 h-24 bg-blue-50 rounded-full mx-auto flex items-center justify-center mb-8 border border-blue-100" data-id="element-55">
          <GraduationCap className="w-12 h-12 text-primary" data-id="element-56" />
        </div>

        <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-8 tracking-tight" data-id="element-57">
          A proposito di EDULABS™
        </h2>

        <div className="relative" data-id="element-58">
          <span className="absolute -top-6 -left-4 text-6xl text-primary/10 font-serif" data-id="element-59">
            "
          </span>
          <p className="text-text-sec text-xl sm:text-2xl leading-relaxed italic font-medium relative z-10" data-id="element-60">
            Abbiamo creato questo sistema per supportare i docenti
            nell'insegnamento dell'Educazione Civica, trasformando un obbligo
            burocratico in un'opportunità di crescita per gli studenti, senza
            sacrificare il tempo libero degli insegnanti.
          </p>
          <span className="absolute -bottom-10 -right-4 text-6xl text-primary/10 font-serif" data-id="element-61">
            "
          </span>
        </div>
      </div>
    </section>;
}